<template>
  <ui-modal v-if="certificatesObject" :notification="true" :close="close">
    <div class="modal-header">
      <h5 class="modal-title">Список доступных сертификатов</h5>
      <button class="btn-close" @click="close"></button>
    </div>
    <div
      class="modal-body p-0"
      v-if="
        certificatesObject &&
        certificatesObject.certs &&
        certificatesObject.certs.filter((cert) => !cert.expired).length > 0
      "
    >
      <div class="ecp-certs-items">
        <div
          class="ecp-cert-item"
          v-for="(item, index) in certificatesObject.certs.filter(
            (cert) => !cert.expired
          )"
          @click="getCertificat(item)"
          :key="index"
        >
          <div class="ecp-cert-icon" />
          <div class="ecp-cert-information">
            <div class="ecp-cert-name">{{ item.name }}</div>
            <div class="ecp-cert-date" v-if="item.validToUTCLocale">
              Действует до: {{ item.validToUTCLocale }}
              <span v-if="item.expired">(Просрочено)</span>
            </div>
            <div class="ecp-cert-date" v-else>
              Не удалось определить дату действия подписи
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="modal-body">Нет доступных действующих сертификатов.</div>
  </ui-modal>
</template>

<script setup>
const props = defineProps({
  certificatesObject: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(["close", "getCertificat"]);

const close = () => {
  emit("close");
};

const getCertificat = (item) => {
  emit("getCertificat", item);
};
</script>